import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GametypeService {

  rootUri = (environment.ktRootUri) ? environment.ktRootUri : "";
  constructor(private http: HttpClient) { }

  getGameTypes(): Observable<GameType[]> {
    return this.http.get<GameType[]>(this.rootUri + `/api/admin/game-types`);
  }
}
